import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

export default function (props) {
  return (
    <SvgIcon viewBox="0 0 12 12" style={{width: '12px', height: '12px'}} {...props}>
      <path fill="none" fillRule="evenodd" stroke="#464646" strokeWidth="2" d="M1 3.205L5.795 8l5-5"/>
    </SvgIcon>
  )
}